var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFloor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#313840",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.237 26.73H8.485a.6.6 0 0 1-.6-.6V5.219a.6.6 0 0 1 .6-.6h20.596c.331 0 .6.268.6.6v11.564a.6.6 0 0 1-.6.6h-3.364v8.588c0 .332-.268.6-.599.6h-5.385a.6.6 0 0 1-.6-.6v-3.01a.6.6 0 0 1 1.2 0v2.41h4.185v-8.588a.6.6 0 0 1 .6-.6h3.363V5.819H9.085v19.71h3.552v-2.25a.6.6 0 1 1 1.2 0v2.85a.6.6 0 0 1-.6.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.258 15.332a.6.6 0 0 1-.6-.6V5.218a.6.6 0 1 1 1.2 0v9.514a.6.6 0 0 1-.6.6M15.455 15.007h-6.97a.6.6 0 0 1 0-1.2h6.97a.6.6 0 1 1 0 1.2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloor);
export default __webpack_public_path__ + "static/media/floor.218b97ed766410eecd93dd0559fd46ce.svg";
export { ForwardRef as ReactComponent };